import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const StudentAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "How does Practido help in Olympiad exam preparation?",
      content: `Practido makes Olympiad prep way easier as an e-learning online platform. It provides practice tests and topic-wise quizzes, offering one-to-one live buddy challenge and open challenge feature to students. This helps in engaging in healthy competition with friends, by earning points, coins, and trophies, this encouraging further participation.`,
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: "Which classes and subjects does Practido cover?",
      content:
        "Practido covers the core subjects students need for strong academic growth: Maths, Science, English, and Computer. It supports multiple classes from 1 to 10, making it one of the most flexible online learning platforms for students. Whether you’re in primary, middle school, or preparing for advanced Olympiads, you’ll find structured practice tailored to your level.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "How can I practice math online for free?",
      content:
        "With Practido, practicing Math online for free is incredibly simple. Start your practice test instantly with the initial free features. The comprehensive setup of this e-learning online platform further offers the option for students to choose a paid subscription too.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "How does the Olympiad exam work?",
      content:
        "Olympiad exams are competitive tests designed to evaluate a student’s understanding of concepts beyond regular school-level learning. With Practido Olympiad Practice App (Android & iOShttps://apps.apple.c...https://apps.apple.c...), students can prepare exactly how the actual Olympiad exam works cross platform seamlessly.",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "What is an Olympiad exam?",
      content:
        "An Olympiad exam is a national or international-level competition that challenges students in subjects like Maths, Science, English, and Computer. The goal is to identify young talent and encourage deeper understanding of concepts. ",
    },
    {
      id: "Six",
      ariaExpanded: "false",
      title: "Which Olympiad is best?",
      content:
        "The best Olympiad depends on the student’s goals and interests. For Maths enthusiasts, the International Mathematical Olympiad (IMO) is the most prestigious. For broader skill development, Olympiads like NSO (Science), NCO (Computer), and IEO (English) are excellent choices. Practido supports students preparing for all major Olympiads through powerful tools like topic-based quizzes and exam-style online exam test simulations on the Practido Olympiad e-learning online platform. ",
    },
    {
      id: "Seven",
      ariaExpanded: "false",
      title: "What is an e-learning online platform?",
      content:
        "A digital system that delivers structured learning, assessments, and performance tracking online. Practido enhances this with Olympiad prep, mock tests, and gamified student practice. Beyond video lessons, it organizes curriculum pathways, evaluates understanding through continuous testing, and provides measurable academic insights. With interactive tools, instant feedback, and progress analytics, this e learning ecosystem helps students strengthen weak areas, build confidence, and develop consistent, exam-ready study habits.",
    },
    {
      id: "Eight",
      ariaExpanded: "false",
      title: "Is Practido free for students?",
      content:
        "Free practice features are available, with optional premium tools for advanced preparation. This flexible access model allows every student to begin learning without barriers, while advanced learners can unlock structured mock exams, deeper analytics, and extended practice libraries. Schools and parents gain transparent progress visibility to support performance effectively. By combining affordability with scalable academic depth, Practido ensures opportunity, strong preparation, and competitive excellence for ambitious students. ",
    },    
    {
      id: "Nine",
      ariaExpanded: "false",
      title: "How is Practido different from other platforms?",
      content:
        "Practido focuses on consistent student practice, analytics, Olympiad readiness, and gamified engagement instead of only lessons. Rather than passive video learning, it drives active performance building through continuous assessment, timed challenges, and measurable improvement tracking. Detailed analytics help parents and educators understand strengths and gaps clearly. With gamified motivation sustaining long-term engagement, students build real exam-ready confidence instead of relying on short-term memorization.",
    },        
    {
      id: "Ten",
      ariaExpanded: "false",
      title: "Which exams can students prepare for?",
      content:
        "School assessments, Olympiads, and competitive academic tests using structured mock exams and concept-wise practice. Preparation follows real exam patterns, progressive difficulty, and subject-wise mastery to build accuracy, speed, and clarity. Regular mock testing simulates exam pressure, while analytics identify improvement areas for focused revision. This structured approach strengthens classroom performance and higher-level competitions, helping students face exams with confidence, familiarity, and strong problem-solving skills.",
    }
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StudentAccordionPage;
